/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useLayout} from '../core'
// HealthStatusIndicator import restored when health indicator is re-enabled
// import {HealthStatusIndicator} from '@/ui/components/HealthStatusIndicator'

/**
 * Compact Footer Component
 *
 * Features:
 * - Fixed positioning at bottom of viewport
 * - Compact height (32px) with minimal padding for space efficiency
 * - Smaller font size and reduced spacing for better space utilization
 * - Contains branding, copyright, version info, and navigation links
 */
const Footer: FC = () => {
  const {classes} = useLayout()

  return (
    <div
      className='footer'
      id='kt_footer'
      style={{width: '100%', fontSize: 'var(--ob-font-size-xs)'}}
    >
      <div
        className={`${classes.footerContainer} d-flex flex-row align-items-center justify-content-between`}
        style={{height: '100%'}} // Use full height of compact footer container
      >
        {/* Left section - Brand attribution */}
        <div className='d-flex align-items-center'>
          <span className='text-muted me-1'>Made with</span>
          <a
            href='https://www.biobam.com'
            target='_blank'
            rel='noreferrer'
            className='text-decoration-none'
            title='Visit BioBam website'
          >
            ❤️
          </a>
          <span className='text-muted ms-1'>by BioBam</span>
        </div>

        {/* Center section - Copyright and version info */}
        <div className='d-flex align-items-center gap-1 text-center'>
          <span className='text-muted'>© 2025 BioBam® - OmicsBox®</span>
          <span className='text-muted'>|</span>
          <div className='text-muted'>v{process.env.REACT_APP_VERSION || 'dev'}</div>
          {/* PRODUCTION: temporarily hidden - health indicator moved to /status page */}
          {/* <HealthStatusIndicator compact={true} /> */}
        </div>

        {/* Right section - Navigation links */}
        <div className='d-flex align-items-center gap-1'>
          <a
            href='https://www.biobam.com/about/'
            target='_blank'
            rel='noreferrer'
            className='text-muted text-hover-primary text-decoration-none'
          >
            About
          </a>
          <span className='text-muted'>|</span>
          <a
            href='https://www.biobam.com/contact-us/'
            target='_blank'
            rel='noreferrer'
            className='text-muted text-hover-primary text-decoration-none'
          >
            Contact
          </a>
          <span className='text-muted'>|</span>
          <a
            href='https://www.biobam.com/blog/'
            target='_blank'
            rel='noreferrer'
            className='text-muted text-hover-primary text-decoration-none'
          >
            Blog
          </a>
        </div>
      </div>
    </div>
  )
}

export {Footer}
